module.exports = __webpack_public_path__ + "img/msg_pic.aa92df61.svg";